export default function GenericError() {
  return (
    <div className="card card--generic">
      <div className="card-icon card-icon--generic">&#9881;</div>
      <h2>Qualcosa è andato storto</h2>
      <p>
        Si è verificato un errore imprevisto durante l'elaborazione
        della tua richiesta.
      </p>
      <p style={{ marginTop: '1rem' }}>
        Ti preghiamo di riprovare tra qualche minuto. Se il problema persiste,
        potresti aver bisogno di un nuovo link di sblocco.
      </p>

      <button className="btn btn--outline" onClick={() => window.history.back()}>
        Torna Indietro
      </button>

      <div className="support-info">
        Per assistenza tecnica, scrivi a:<br />
        <strong>ESGproducts@iongroup.com</strong>
      </div>
    </div>
  );
}
